import { store } from 'common/global-store'
import { getCurrentAuthenticatedUser, getCurrentUserEmail } from 'common/global-store/api'

export function isEmulated() {
    const currentUserEmail = getCurrentUserEmail()
    const emulatedEmail = store.profile$?.profile?.email
    return currentUserEmail !== emulatedEmail && !getCurrentAuthenticatedUser()?.isAnonymous
}
